module.exports = __webpack_public_path__ + "img/switch_on2.b5310f6b.png";